import WhatsAppChat from './WhatsAppChat';

export default WhatsAppChat;
